<template>
  <div>
    <div
      v-if="!chatboxDrawerOpen"
      :class="expand_chatbot ? 'chatbot-container' : 'closed-container'"
    >
      <v-btn fab @click="minimiseChatbot($event)" small class="mt-3" text>
        <v-icon v-if="!expand_chatbot"> mdi-step-backward </v-icon>
        <v-icon v-else size="30"> mdi-step-forward </v-icon>
      </v-btn>
      <v-btn
        color="primary"
        fab
        class="mr-3 fixed-btn"
        style="bottom: 4.2rem"
        v-if="expand_chatbot"
        @click="chatboxDrawerOpen = !chatboxDrawerOpen"
      >
        <v-avatar size="42">
          <img src="../assets/Icons/Group_227.svg" alt="Chat" />
        </v-avatar>
      </v-btn>
    </div>
    <!-- ChatBox Navigation Drawer Component -->
    <ChatBox
      :isDrawerOpen="chatboxDrawerOpen"
      @toggle-drawer="chatboxDrawerOpen = $event"
    ></ChatBox>
  </div>
</template>

<script>
import ChatBox from "./ChatBox.vue";

export default {
  components: {
    ChatBox,
  },
  data() {
    return {
      chatboxDrawerOpen: false,
      expand_chatbot: true,
    };
  },
  methods: {
    minimiseChatbot(event) {
      this.expand_chatbot = !this.expand_chatbot;
      event.currentTarget.blur();
    },
  },
};
</script>

<style scoped>
.fixed-btn {
  z-index: 10;
  position: fixed;
  bottom: 6rem;
  right: 1.3rem;
}

.chatbot-container {
  position: fixed;
  bottom: 4rem;
  right: 0rem;
  width: 8rem;
  height: 3.8rem;
  background-color: rgba(250, 175, 25, 0);
  border-radius: 3rem 0 0 3rem;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10;
}

.closed-container {
  position: fixed;
  bottom: 4rem;
  right: 0rem;
  width: 2rem;
  height: 3.8rem;
  background-color: rgba(250, 175, 25, 0);
  border-radius: 3rem 0 0 3rem;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10;
}
</style>
